import { FOCUS_DIVERSIONS_TAB_REQUEST } from '../constants/ActionTypes';

/**
 * UI-routing slice for cross-component tab-focus signals.
 *
 *   focusDiversionsRequestedAt — monotonic epoch-ms timestamp updated on every
 *     FOCUS_DIVERSIONS_TAB_REQUEST dispatch. RoutesOverviewPage watches the
 *     value in componentDidUpdate and switches to the Diversions tab when the
 *     value advances WHILE the page is mounted.
 *
 *   Why a timestamp + componentDidUpdate watcher rather than a saga or a
 *   transient flag the consumer clears? Because the page may not be mounted
 *   when the dispatch fires (the TM might be on a different page composing
 *   the diversion notification). Clearing on consumption would race; a
 *   monotonic timestamp lets each consumer record its last-seen value and
 *   only react when the value advances during its own lifecycle. Works as a
 *   one-shot signal without the lifecycle-coupling problems of a transient
 *   flag.
 *
 * Slice is plain-object (matches every other reducer in this codebase
 * — no ImmutableJS).
 */
export const initialState = {
  focusDiversionsRequestedAt: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FOCUS_DIVERSIONS_TAB_REQUEST:
      return {
        ...state,
        focusDiversionsRequestedAt: Date.now(),
      };
    default:
      return state;
  }
};
